import React from 'react';

const BlogSection = () => {
  const blogPosts = [
    {
      title: "200+ Best Icebreaker questions for Team Building at work place",
      description: "Workplace appropriate Ice-breaker questions for your work meeting. 120+ fun questionnaire for your next team building activity on Zoom or Slack.",
      image: "/assets/Icebreakers_Work_Small.jpg",
      category: "THE RICOTTA BLOG",
      pageUrl: "https://www.ricotta.team/blog/icebreaker-questions-for-team-building-work"
    },
    {
      title: "10+ Fun Virtual Team Building Activities and Games for your Remote Team",
      description: "Must-try Virtual Team Building Activities, Games and Ideas for remote team engagement online on Slack or Zoom conference calls for your team.",
      image: "/assets/Virtual_Games_Small.jpg",
      category: "THE RICOTTA BLOG",
      pageUrl: "https://www.ricotta.team/blog/virtual-team-building-activities-games"
    },
    {
      title: "100+ Would you rather questions for work",
      description: "Workplace appropriate would you rather Icebreaker questions for your team on Slack. It's Friday afternoon and you've just finished a lot of work and you are bored working remotely.",
      image: "/assets/Would_you_rather.jpg", 
      category: "THE RICOTTA BLOG",
      pageUrl: "https://www.ricotta.team/blog/would-you-rather-questions-for-work-place"
    },
    {
      title: "5 Minute Team Building Activities & Games For Work",
      description: "Team-building doesn't have to be time-consuming to be effective. Even with just five minutes, you can bring your team closer, boost morale, and make your workplace more connected",
      image: "/assets/5Min_Activities.jpg",
      category: "THE RICOTTA BLOG",
      pageUrl: "https://www.ricotta.team/blog/5-minute-team-building-activities"
    }
  ];

  return (
    <div className="blog-section" style={{ padding: '2rem' }}>
      <div className="container-fluid">
        <div style={{ marginBottom: '2rem' }}>
          <h2 style={{ 
            color: '#E04F60', 
            marginBottom: '0.5rem',
            fontSize: '1.8rem',
            fontWeight: '600'
          }}>
            Team Building and Employee Engagement
          </h2>
        </div>

        <div className="row">
          {blogPosts.map((post, index) => (
            <div key={index} className="col-lg-3 col-md-6 mb-4">
              <div 
                className="card h-100 blog-card"
                style={{
                  border: 'none',
                  borderRadius: '12px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  overflow: 'hidden'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.15)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
                }}
                onClick={() => {
                  window.open(post.pageUrl, '_blank', 'noopener,noreferrer');
                }}
              >
                {/* Blog post image */}
                <div style={{
                  height: '200px',
                  backgroundImage: `url(${post.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundColor: '#f8f9fa'
                }}>
                </div>

                <div className="card-body" style={{ padding: '1.5rem' }}>
                  <h5 className="card-title" style={{
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    color: '#333',
                    marginBottom: '1rem',
                    lineHeight: '1.4'
                  }}>
                    {post.title}
                  </h5>
                  
                  <p className="card-text" style={{
                    fontSize: '0.9rem',
                    color: '#6c757d',
                    lineHeight: '1.5',
                    marginBottom: '1rem'
                  }}>
                    {post.description}
                  </p>

                  <div style={{
                    fontSize: '0.8rem',
                    color: '#E04F60',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
                    {post.category}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="text-center mt-4">
          <a 
            href="https://ricotta.team/blog" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              color: '#E04F60',
              textDecoration: 'none',
              fontSize: '1rem',
              fontWeight: '600',
              padding: '0.75rem 2rem',
              border: '2px solid #E04F60',
              borderRadius: '8px',
              transition: 'all 0.2s',
              display: 'inline-block'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#E04F60';
              e.target.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#E04F60';
            }}
          >
            View All Blog Posts →
          </a>
        </div>
      </div>
    </div>
  );
};

export default BlogSection;

